import { cloneElement, useState } from "react";
import type { MouseEvent, ReactElement } from "react";
import Tooltip from "@mui/material/Tooltip";

// Tooltip que só abre quando o texto está de fato cortado (ellipsis):
// no hover, compara a largura visível do elemento com a largura total
// do conteúdo — texto que cabe inteiro não ganha tooltip redundante.
// O visual (navy, seta, transição) vem do MuiTooltip global do tema.
export const EllipsisTip = ({
  text,
  children,
}: {
  text: string;
  children: ReactElement;
}) => {
  const [open, setOpen] = useState(false);
  return (
    <Tooltip
      title={text}
      open={open}
      onClose={() => setOpen(false)}
      placement="top"
    >
      {cloneElement(children, {
        onMouseEnter: (event: MouseEvent<HTMLElement>) => {
          const el = event.currentTarget;
          setOpen(el.scrollWidth > el.clientWidth);
        },
        onMouseLeave: () => setOpen(false),
      })}
    </Tooltip>
  );
};
